import Vue from 'vue'

import { services } from '@/utils'

import render from './render'

export default {
  name: 'FilterSendings',

  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    filter() {
      Vue.router.push({
        name: services.sendings,
        query: {
          currentTab: 'outgoing',
          ...this.query
        }
      })
    }
  },

  render
}
